import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import cc from 'classcat'

import Icon from '../Icon'

class TabBarDropdown extends Component {
  constructor(props) {
    super(props)
    this.state = { isDropdownShown: false }
    this.dropdownRef = createRef()
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  render() {
    const { title, icon, itemClass, children, id } = this.props
    const { isDropdownShown } = this.state

    return (
      <div
        ref={this.dropdownRef}
        className={ cc([itemClass, 'tab-bar-dropdown', 'right-tab-bar-item']) }
        onClick={ this._toggleDropdown(isDropdownShown) }
        id={ id }
        onKeyDown={ this._toggleDropdown(isDropdownShown) }
        role="button"
        tabIndex={ 0 }>
        <div className="tab-bar-dropdown-title">
          <Icon name={ icon } />
          <span>
            { title }
          </span>
        </div>
        { isDropdownShown ? this._renderDropdown(children) : null }
      </div>
    )
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      const { isDropdownShown } = this.state
      if (isDropdownShown) {
        this.setState({ isDropdownShown: false })
      }
    }
  }

  _renderDropdown = content => (
    <div className="tab-bar-dropdown-menu">
      { content }
    </div>
  )

  _toggleDropdown = wasDropdownShown => () => this.setState({ isDropdownShown: !wasDropdownShown })
}

TabBarDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  itemClass: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]),
}

TabBarDropdown.defaultProps = {
  itemClass: [],
  icon: null,
}

export default TabBarDropdown
